import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id B786A80C-161C-492C-B405-A10087092CDC
 * name contain-end
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/contain-end.svg
 * tags
 */
export const ContainEndIcon = createSvgIcon(<><path d="M7,17V15H9V17H7M11,17V15H13V17H11M15,17V15H17V17H15M22,3V21H16V19H20V5H16V3H22Z" /></>, 'ContainEndIcon');
export default ContainEndIcon